<template>
    <div class="modal-default-brand">
      <dass-dialog
        v-if="showModalDefaultBrand"
        title=" " 
        size="medium"
        ref="ModalDefaultBrand"
        class="dass-dialog--default-brand"
        @close="closeModal"
      >
        <template #content>            
            <div class="dass-title">
              <h3>{{ title }} </h3>
            </div>
            <div class="dass-subtitle" v-html="message">              
            </div> 
            <div class="dass-actions">                
                <dass-button class="dass-buttons-wallet" :class="this.isSafari ? `dass-button-primary-${this.brandName}` : ''" @click="actionButton" type="button" variant="tertiary">
                  {{ labelButton }}
                </dass-button>
            </div>
            <div v-if="messageSmallFooter" class="dass-message-refund">
              <small>{{ messageSmallFooter }}</small>
            </div>             
        </template>
      </dass-dialog>
    </div>
  </template>
  
<script>
import { useIsSafari } from '@/composables/useIsSafari'
  
export default {
  name: 'ModalDefaultBrand',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    messageSmallFooter: {
      type: String,
      default: '',  
    },
    title: {
      type: String,
      default: '',  
    },
    message: {
      type: String,
      default: '',
    },
    labelButton: {
      type: String,
      default: '',
    }
  },
  emits: ['closeModal'],  
  setup() {
    const { isSafari, brandName } = useIsSafari()
    
    return {
      isSafari,
      brandName
    }
  },
  computed: {
    showModalDefaultBrand() {      
      return this.showModal
    }
  },
  methods: {
    closeModal() {          
      this.$emit('closeModal')      
    },  
    actionButton() {
      this.$emit('actionButton')
    },       
  },    
}
</script>
  
<style lang="scss">
  .modal-default-brand {
    .dass-dialog--close {      
      padding: 0 !important;
      height: 50px;
      width: 50px;
    }
    .dass-dialog--header {
      padding-top: 0 !important;
      padding-right: 0 !important;
    }
    .dass-dialog--control {
      border-radius: 10px !important;
    }    
    .dass-dialog--contents {
      padding-top: 0 !important;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-right: 1rem;
      margin-left: 1rem;
    }    
    .dass-subtitle {       
      text-transform: none;   
      padding-bottom: var(--space);
    }
    label {
      font-weight: bold;
    }
    .dass-message-refund {
        margin-bottom: var(--space__0-5x);
        margin-top: var(--space__0-5x);
        line-height: normal !important;
    }
    .dass-actions {
      margin-top: var(--space__1-5x);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      row-gap: var(--space);
      .dass-card-content-container {
        border: 1px solid #E9E9E9;
        border-radius: var(--theme-border-radius);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: auto;        
        .dass-card-content {     
          padding: var(--space);     
          text-transform: uppercase;
          display: flex;
          flex-direction: column;
          align-items: center; 
          row-gap: var(--space__0-5x);  
        }
      } 
    }
  }
  .theme-umbro {
    .dass-dialog--control {
      background-color: var(--theme-white) !important;
      color: var(--color-default-umbro) !important;
    }
    .dass-link {
      color: var(--color-default-umbro) !important;
    }
    .dass-button__tertiary {
      color: var(--theme-white) !important;
      text-decoration: none !important;
    }
    .dass-button__primary {
      background-color: var(--theme-white) !important;
      color: var(--theme-color) !important;
      transition: background-color 0.3s ease;
      &:hover {
        background-color: #758396;
      }
    }
    .dass-button-shopping-voucher {
      transition: color 0.3s ease !important;
      &:hover {
        color: white !important;
      }
    }
  }
</style>
  